import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { WordMark } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { apiErrorMessage } from "@/lib/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate(location.state?.from || "/dashboard");
    } catch (err) {
      setError(apiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[92vh] flex items-center justify-center px-4 sm:px-6 pt-24 pb-16">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <WordMark className="h-28 w-28" />
        </div>
        <h1 className="font-anton uppercase tracking-tighter text-cream text-3xl sm:text-4xl text-center">Member Login</h1>
        <p className="text-smoke text-center mt-2 text-sm">Enter the arena.</p>

        <form onSubmit={handleSubmit} className="mt-10 space-y-5 bg-surface border border-line p-6 sm:p-8" data-testid="login-form">
          {error && (
            <p className="text-red-400 text-sm" data-testid="login-error-message">
              {error}
            </p>
          )}
          <div>
            <label className="text-xs uppercase tracking-widest text-smoke">Email</label>
            <Input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="rounded-none bg-void border-line text-cream mt-2 h-12 focus-visible:ring-gold focus-visible:border-gold"
              data-testid="login-email-input"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-smoke">Password</label>
            <Input
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="rounded-none bg-void border-line text-cream mt-2 h-12 focus-visible:ring-gold focus-visible:border-gold"
              data-testid="login-password-input"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="rounded-none bg-gold text-void hover:bg-gold-hover font-bold uppercase tracking-wider w-full h-12"
            data-testid="login-submit-button"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Log In"}
          </Button>
        </form>
        <p className="text-center text-smoke text-sm mt-6">
          New to Elysium?{" "}
          <Link to="/register" className="text-gold hover:underline" data-testid="login-register-link">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
